module.exports = __webpack_public_path__ + "static/media/datacroft-logo.8ff3a2c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/datacroft-logo.svg
// module id = 1355
// module chunks = 0